export default __webpack_public_path__ + "static/media/Kanipakam-slider-06@2x.9285b0eb.png";